import { isWidthUp } from "@material-ui/core";

export type ScreenWidth = "xs" | "sm" | "md" | "lg" | "xl";

const getNext = (width: ScreenWidth): ScreenWidth => {
  switch (width) {
    case "xs":
      return "sm";
    case "sm":
      return "md";
    case "md":
      return "lg";
    case "lg":
      return "xl";
    case "xl":
      return "xl";
    default:
      return "xs";
  }
};

export const isWidth = (
  width: ScreenWidth, screenWidth: ScreenWidth
) => {
  return (
    isWidthUp(
      width,
      screenWidth
    ) &&
    (width === "xl" || !isWidthUp(
      getNext(width),
      screenWidth
    ))
  );
};
